import { render, staticRenderFns } from "./DataTableHeader.vue?vue&type=template&id=38530c45&"
import script from "./DataTableHeader.vue?vue&type=script&lang=ts&"
export * from "./DataTableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DataTableHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
